import ArticleLayout from '@/pages/article/components/ArticleLayout';
import { allArticles } from '@/mocks/articleContents';

export default function KakobuyShoesSpreadsheet() {
  return <ArticleLayout content={allArticles[3]} />;
}